import React from "react";
import logo from "../assests/img/bridge-logo.png";
import "../assests/css/loading-overlay.css";

function LoadingOverlay({ message = "Loading..." }) {
  return (
    <div className="loading-overlay" role="status" aria-live="polite" aria-busy="true">
      <div className="loading-overlay-card">
        <div className="loading-overlay-spinner" aria-hidden="true" />
        <p className="loading-overlay-text">{message}</p>
      </div>
    </div>
  );
}

export default LoadingOverlay;
